import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import Alert from 'react-s-alert';
import { get } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import PersonOfConcernContent from './PersonOfConcernContent';
import PersonOfConcernModal from '../modal/PersonOfConcernModal';

const form = {
  keyword: '',
};

function PersonOfConcernContainer({
  match,
  history,
  getPersonOfConcernList,
  personOfConcernList,
  isLoading,
  removePersonOfConcern,
  personOfConcernListPager,
  getSinglePersonOfConcern,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PersonOfConcernModal type="NEW" />,
      title: 'Add Person-of-Concern',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PersonOfConcernModal type="EDIT" updateList={data.attributes} personOfConcernId={data.id} />,
      title: 'Update Person-of-Concern',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Person-of-Concern?',
      () => {
        removePersonOfConcern(data.id, () => {
          getPersonOfConcernList({ isPaginate: 1 });
          const id = _.get(personOfConcernList, '0.id');
          if (id !== data.id) {
            history.push(`${id}`);
            getSinglePersonOfConcern(id);
          } else {
            window.location.pathname = '/rpt/land/land-settings/personOfConcern';
            history.replace({
              pathname: '/rpt/land/land-settings/personOfConcern',
            });
          }
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getPersonOfConcernList({ isPaginate: 1 });
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
    isPaginate: 1,
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getPersonOfConcernList({ isPaginate: 1, q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  const token = get('token') || '';

  const [file, setFile] = useState({});

  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const postFormData = url => (formdata, onProgress) => new Promise((resolve, reject) => {
    try {
      const xhr = new XMLHttpRequest();
      xhr.timeout = 300000;
      // eslint-disable-next-line no-unused-vars
      xhr.addEventListener('timeout', e => resolve({
        status: 400,
        message: 'Request Timeout, Please try again.',
      }));
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`,);
      xhr.onload = () => {
        try {
          const jsonResponse = JSON.parse(xhr.response);
          const response = {
            status: xhr.status, // jsonResponse.status,
            data: jsonResponse,
          };
          resolve(response);
        } catch (err) {
          reject(err);
        }
      };
      xhr.onerror = () => {
        const errRes = {
          data: false,
          message: 'Oops..Something went wrong.',
        };
        Alert.error(errRes);
        return resolve(errRes);
      };
      if (xhr.upload) {
        xhr.upload.onprogress = (evt) => {
          if (evt.lengthComputable) {
            const progress = Math.ceil(((evt.loaded) / evt.total) * 100);
            if (onProgress) { onProgress(progress); }
          }
        };
      }
      xhr.send(formdata);
    } catch (err) {
      reject(err);
    }
  });

  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();
    try {
      data.append('file', file);
      data.append(
        'subject',
        'PERSON_OF_CONCERN'
      );
      const res = await postFormData(`${process.env.REACT_APP_WS}api/v1/rpt/administrator/settings/csv_imports`)(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        getPersonOfConcernList({ isPaginate: 1 });
      }
      if (_.get(res, 'status') === 422) {
        Alert.error(_.get(res, 'data.message'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  return (
    <div className="card-content-listing">
      <div className="ml-auto row-nav">
        <div className="float-left">
          <div className="form-group">
            {isLoading && (
              <button
                disabled
                type="button"
                className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
              >
                <i className="fa fa-spin fa-spinner" />
              </button>
            )}
          </div>
        </div>
        <div className="float-right">
          <div className="form-group">
            {!isLoading && (
              <input
                type="file"
                className="btn btn-link input-upload"
                onChange={fileHandler}
              />
            )}
          </div>
        </div>
        <div className="flow-right">
          <div className="form-group">
            <button type="button" onClick={onUploadFile} className="ml-2 btn btn-link button-upload">
              Upload
            </button>
          </div>
        </div>
      </div>
      <Route
        path={`${match.path}/:personOfConcernId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Person-of-Concern"
            getData={getPersonOfConcernList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:personOfConcernId?`}
            listName="Person-of-Concern"
            label="Person-of-Concern"
            renderItem={(item) => (
              <div className="p-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.first_name')}{" "}
                  {_.get(item, 'attributes.middle_name')}{" "}
                  {_.get(item, 'attributes.last_name')}{" "}
                  {_.get(item, 'attributes.suffix') || ''}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(
                    item,
                    'attributes.is_approver'
                  ) === 1
                    ? 'Approver'
                    : ''}

                  {(_.get(
                    item,
                    'attributes.is_approver'
                  ) === 1 && _.get(
                    item,
                    'attributes.is_recommender'
                  ) === 1 && _.get(
                    item,
                    'attributes.is_assessor'
                  ) === 0) && ', '}

                  {(_.get(
                    item,
                    'attributes.is_approver'
                  ) === 1 && _.get(
                    item,
                    'attributes.is_recommender'
                  ) === 1 && _.get(
                    item,
                    'attributes.is_assessor'
                  ) === 1) && ', '}

                  {(_.get(
                    item,
                    'attributes.is_approver'
                  ) === 1 && _.get(
                    item,
                    'attributes.is_recommender'
                  ) === 0 && _.get(
                    item,
                    'attributes.is_assessor'
                  ) === 1) && ', '}

                  {_.get(
                    item,
                    'attributes.is_recommender'
                  ) === 1
                    ? 'Recommender'
                    : ''}

                  {(_.get(
                    item,
                    'attributes.is_approver'
                  ) === 0 && _.get(
                    item,
                    'attributes.is_recommender'
                  ) === 1 && _.get(
                    item,
                    'attributes.is_assessor'
                  ) === 1) && ', '}

                  {(_.get(
                    item,
                    'attributes.is_approver'
                  ) === 1 && _.get(
                    item,
                    'attributes.is_recommender'
                  ) === 1 && _.get(
                    item,
                    'attributes.is_assessor'
                  ) === 1) && ', '}

                  {_.get(
                    item,
                    'attributes.is_assessor'
                  ) === 1
                    ? 'Assessor'
                    : ''}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            selected={params.personOfConcernId}
            data={personOfConcernList}
            dataPager={personOfConcernListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:personOfConcernId?`}
                    render={() => (
                      <PersonOfConcernContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:personOfConcernId?`}
                  render={() =>
                    !params.personOfConcernId && personOfConcernList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(personOfConcernList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

PersonOfConcernContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getPersonOfConcernList: PropTypes.instanceOf(Function).isRequired,
  personOfConcernList: PropTypes.instanceOf(Array).isRequired,
  personOfConcernListPager: PropTypes.instanceOf(Object).isRequired,
  removePersonOfConcern: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSinglePersonOfConcern: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  personOfConcernList: _.get(api, `${c.GET_PERSON_OF_CONCERN}.list`) || [],
  personOfConcernListPager: _.get(api, `${c.GET_PERSON_OF_CONCERN}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_PERSON_OF_CONCERN) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PersonOfConcernContainer);
